export default {
  coverLetter: null,
  isLoadLetterPreview: false,
  coverLetterPreview: null,
  coverLetterPreviewImageFiles: null,
  coverLetterPreviewPDF: null,
};
